import { Typography } from "@mui/material";
import { MprcLink } from "components";
import { KnowledgeFeedOrder, NotificationType, PublicationType } from "generated/CoreApi_v1";
import React, { ReactNode } from "react";
import { Link } from "react-router";
import { KnowledgePaths } from "routes/KnowledgeRouter";
import { MessengerResolver } from "views/foundation/notification/resolvers/MessengerResolver";
import { ChannelProcessInviteDialog } from "views/knowledge/channels/dialogs/ChannelProcessInviteDialog";
import { ModeratorMessageDialog } from "views/knowledge/feed/FeedModeration/ModeratorMessageDialog";

////////////////////////////////////////////////////////////////////////////////

export class KnowledgeResolver extends MessengerResolver {

    static messengerId: string[] = [
        "Knowledge.*",
    ];

    protected publicationLink(param?: string): React.ReactNode {

        if (this.notificationAction && this.notificationAction.keys?.length > 1) {
            try {
                if (this.notificationAction.keys[1] == PublicationType.Question)
                    return <Link to={`${KnowledgePaths.QuestionPublicationViewer}/${this.notificationAction.keys[0]}${param ? `?${param}` : ''}`} title={this.notificationAction.title} onClick={() => this.onCloseMenu()}>
                        <Typography variant="linkAction">{this.notificationAction.title}</Typography>
                    </Link>;
                else if (this.notificationAction.keys![1] == PublicationType.Answer && this.notificationAction.keys.length > 2)
                    return <Link to={KnowledgePaths.PublicationViewerResolver(this.notificationAction.keys[0], this.notificationAction.keys[1], this.notificationAction.keys[2])} title={this.notificationAction.title} onClick={() => this.onCloseMenu()}>
                        <Typography variant="linkAction">{this.notificationAction.title}</Typography>
                    </Link>;
                else if (this.notificationAction!.keys![1] != PublicationType.Question && this.notificationAction!.keys![1] != PublicationType.Answer)
                    return <Link to={KnowledgePaths.PublicationViewerResolver(this.notificationAction.keys[0], this.notificationAction.keys[1], param)} title={this.notificationAction.title} onClick={() => this.onCloseMenu()}>
                        <Typography variant="linkAction">{this.notificationAction.title}</Typography>
                    </Link>;
            }
            catch (e: any) {
                console.error(e);
            }
        }

        return <b>{this.notificationAction?.title ?? "Publication?"}</b>;
    }

    protected channelLink(): React.ReactNode {
        return <Link to={`${KnowledgePaths.FeedChannel(this.notificationAction!.keys![0], KnowledgeFeedOrder.Latest)}`} title={this.notificationAction!.title} onClick={() => this.onCloseMenu()}>
            <Typography variant="linkAction">{this.notificationAction!.title}</Typography>
        </Link>;
    }

    protected topicLink(): React.ReactNode {
        return <Link to={`${KnowledgePaths.FeedTopic(this.notificationAction!.keys![0], KnowledgeFeedOrder.Latest)}`} title={this.notificationAction!.title} onClick={() => this.onCloseMenu()}>
            <Typography variant="linkAction">{this.notificationAction!.title}</Typography>
        </Link>;
    }

    protected translateAction(): ReactNode {
        if (this.notificationActionKeys == null
            && this.notification.notificationTypeId != NotificationType.KnowledgePublicationPendingApproval
            && this.notification.notificationTypeId != NotificationType.KnowledgeChannelPendingSubscription
        ) {
            return this.notificationAction?.title ?? "?";
        }

        switch (this.notification.notificationTypeId) {
            case NotificationType.KnowledgeChannelNewModerator:
            case NotificationType.KnowledgeChannelNewModeratorSelected:
            case NotificationType.KnowledgeChannelNewOwner:
            case NotificationType.KnowledgeChannelNewMember:
            case NotificationType.KnowledgeChannelSubscriptionApproved:
            case NotificationType.KnowledgeChannelCancelMember:
            case NotificationType.KnowledgeChannelSubscriptionRejected:
            case NotificationType.KnowledgeChannelNewPublication:
            case NotificationType.KnowledgeChannelRequestAccess:
                return this.channelLink();

            case NotificationType.KnowledgeTopicNewPublication:
                return this.topicLink();

            case NotificationType.KnowledgeCommentNewAnswerYourComment:
            case NotificationType.KnowledgeCommentNewYourPublication:
            case NotificationType.KnowledgeListNewPublicationFollower:
            case NotificationType.KnowledgeMentionPublication:
            case NotificationType.KnowledgePublicationApproved:
            case NotificationType.KnowledgePublicationRejected:
            case NotificationType.KnowledgePublicationLike:
                return this.publicationLink();

            case NotificationType.KnowledgePublicationPendingApproval:
                return <Link to={KnowledgePaths.FeedModeration} title={this.notificationAction!.title} onClick={() => this.onCloseMenu()}>
                    <Typography variant="linkAction">{this.notificationAction!.title}</Typography>
                </Link>;

            case NotificationType.KnowledgeChannelPendingSubscription:
                return <Link to={KnowledgePaths.FeedModerationSubscriptions} title={this.notificationAction!.title} onClick={() => this.onCloseMenu()}>
                    <Typography variant="linkAction">{this.notificationAction!.title}</Typography>
                </Link>;

            case NotificationType.KnowledgeRequestUnblockPublication:
                return <Link to={KnowledgePaths.FeedModerationPublications} title={this.notificationAction!.title} onClick={() => this.onCloseMenu()}>
                    <Typography variant="linkAction">{this.notificationAction!.title}</Typography>
                </Link>;

            case NotificationType.KnowledgeChannelInvite:
                return (
                    <MprcLink
                        color="highlight.main"
                        onClick={
                            () => {
                                this.renderDialog(
                                    <ChannelProcessInviteDialog
                                        inviteId={this.notificationAction!.keys[0]}
                                        channelName={this.notificationAction!.title}
                                        notificationId={this.notification.notificationId}
                                        onClose={() => this.renderDialog(null)}
                                    />
                                );
                            }
                        }
                    >
                        {this.notificationAction?.title}
                    </MprcLink >
                );

            case NotificationType.KnowledgeAuthorNewPublication:
                return this.notificationAction?.keys?.length == 1
                    ? <Link key={(new Date()).getDate()} to={KnowledgePaths.FeedUserProfile(this.notificationAction!.keys[0])} title={this.notificationAction?.title} onClick={() => this.onCloseMenu()}>
                        <Typography variant="linkAction">{this.notificationAction?.title ?? "?"}</Typography>
                    </Link>
                    : <b>{this.notificationAction?.title ?? "?"}</b>;

            case NotificationType.KnowledgeRequesterReportAnalysed:
                return (
                    <MprcLink
                        onClick={
                            () => {
                                this.onCloseMenu();
                                this.renderDialog(
                                    <ModeratorMessageDialog
                                        data={
                                            {
                                                publicationId: this.notificationAction!.keys[0],
                                                publicationType: this.notificationAction!.keys[1],
                                                publicationTitle: this.notificationAction!.keys[2],
                                                message: this.notificationAction!.keys[3],
                                                actionResponse: this.notificationAction!.keys[4],
                                                masterPublicationId: this.notificationAction!.keys[5],
                                            }
                                        }
                                        onClose={() => this.renderDialog(null)}
                                    />
                                );
                            }
                        }
                    >
                        {this.notificationAction?.title}
                    </MprcLink >
                );

            default:
                return this.publicationLink();
        }
    }
}
